import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, Route, Switch, useParams, useLocation } from 'react-router-dom';
import { Button, Col, Container, Row, UncontrolledTooltip } from 'reactstrap';
import { actions } from '../../../context';
import BtxSwitch from '../../Forms/BtxSwitch';
import CommunicationView from './CommunicationView';
import CommunicationListItem from './CommunicationListItem';
import NewCommunication from './NewCommunication';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './Communications.css';

// TODO: do better refactor later, low importance for now
const Communications = () => {
    const loc = useLocation();
    const { practiceId } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState({});
    // TODO: push this into redux so we can get forced updates and track redux state
    const [communications, setCommunications] = useState([]);
    const [includeClosed, setIncludeClosed] = useState(false);

    const toggleClosed = useCallback(
        () => setIncludeClosed(!includeClosed),
        [includeClosed]
    );

    const refresh = useCallback(
        () =>
            dispatch(
                actions.communication.getCommunications(
                    practiceId,
                    includeClosed
                )
            )
                .then(
                    (res) => setCommunications(res?.data || []),
                    (err) => console.error(err)
                )
                .finally(() => setLoading(false)),
        [practiceId, includeClosed, dispatch]
    );

    useEffect(() => {
        setLoading(true);
        refresh();
    }, [dispatch, practiceId, includeClosed, refresh]);

    return (
        <Container className="text-light mb-4">
            <Row>
                <Col lg="5" className="sc-glass sc-rounded p-3">
                    <div className="text-nowrap d-flex justify-content-between">
                        <div>
                            <h3>Communications</h3>
                        </div>
                        <div>
                            <Link
                                className="text-decoration-none"
                                to={`/practices/${practiceId}/new-communication`}>
                                <Button
                                    id="newCommunication"
                                    className="rounded-circle bg-light text-primary"
                                    color="primary">
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                                <UncontrolledTooltip target="newCommunication">
                                    Create a new communication
                                </UncontrolledTooltip>
                            </Link>
                        </div>
                    </div>
                    <div className="text-nowrap d-flex justify-content-between">
                        <div className="pt-2">Show closed communications</div>
                        <div>
                            <BtxSwitch
                                value={includeClosed}
                                onChange={toggleClosed}
                            />
                        </div>
                    </div>
                    <div className="border-top" style={communicationListStyles}>
                        {loading ? (
                            <h5 className="text-center m-3">
                                Loading Communications
                            </h5>
                        ) : (
                            <>
                                {/* TODO: virtualize this list. Memoize this list as this will render every time. */}
                                {communications?.map((c) => {
                                    let {
                                        id: communicationId,
                                        title: communicationTitle,
                                        communicationType,
                                        notificationCount,
                                        commentCount,
                                        isOpen: communicationIsOpen,
                                        displayId,
                                        createdByFirstName,
                                        createdByLastName,
                                        createdDate,
                                    } = c;
                                    let isSelected =
                                        loc.pathname.includes(communicationId);
                                    let props = {
                                        isSelected,
                                        communicationId,
                                        communicationTitle,
                                        communicationType,
                                        notificationCount,
                                        commentCount,
                                        communicationIsOpen,
                                        displayId,
                                        createdByFirstName,
                                        createdByLastName,
                                        createdDate,
                                    };
                                    return (
                                        <CommunicationListItem
                                            key={communicationId}
                                            practiceId={practiceId}
                                            {...props}
                                        />
                                    );
                                })}
                                {communications?.length === 0 && (
                                    <h5 className="text-center m-4">
                                        No{' '}
                                        {includeClosed === true ? '' : 'open '}
                                        communications at this time
                                    </h5>
                                )}
                            </>
                        )}
                    </div>
                </Col>
                <Switch>
                    <Route path="/practices/:practiceId/communications/:communicationId">
                        <CommunicationView refreshCommunications={refresh} />
                    </Route>
                    <Route path="/practices/:practiceId/new-communication">
                        {/* TODO: do better refactor later, low importance for now */}
                        <NewCommunication
                            practiceId={practiceId}
                            refresh={refresh}
                        />
                    </Route>
                </Switch>
            </Row>
        </Container>
    );
};

const communicationListStyles = {
    minHeight: '540px',
    maxHeight: '540px',
    overflowY: 'scroll',
};

export default React.memo(Communications);
